import { gql } from "@apollo/client";

export const GET_UPCOMING_INVOICE = gql`
    query GetUpcomingInvoice($userEmailID: String) {
        getUpcomingInvoice(userEmailID: $userEmailID) {
            amountDue
            currentUsage
            periodStart
            periodEnd
            amountRemaining
            currency
            coupons {
                name
                id
            }
            invoiceLineItems {
                description
                amountDue
                quantity
                unitPrice
            }
        }
    }
`;

export const SUBSCRIBE_PLAN = gql`
    mutation SubscribePlan($sourceID: String!) {
        subscribe(sourceID: $sourceID)
    }
`;

export const UNSUBSCRIBE_PLAN = gql`
    mutation UnsubscribePlan {
        unsubscribe
    }
`;
